// Loads TechTarget's <smartforms-techtarget> web component bundle from the smartforms host
// for this environment (see techtarget/environment.js).
import { smartFormsBaseUrl } from '../techtarget/environment';

export function smartformsBundleSrc(hostname = window.location.hostname) {
  return `${smartFormsBaseUrl(hostname)}/registration/v2/ui/smartforms-techtarget/smartforms-techtarget.esm.js`;
}

const loadPromises = new Map();

function loadGateScript(src) {
  if (loadPromises.has(src)) {
    return loadPromises.get(src);
  }

  const loadPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) {
      resolve(existing);
      return;
    }

    const script = document.createElement('script');
    script.type = 'module';
    script.src = src;
    // The attributes TechTarget's own pages put on this script tag, so consent and tag
    // tooling treat it the same way.
    script.setAttribute('data-sentry-element', 'Script');
    script.setAttribute('data-sentry-source-file', 'SmartForm.tsx');
    script.setAttribute('data-nscript', 'afterInteractive');
    script.onload = () => resolve(script);
    script.onerror = (err) => {
      loadPromises.delete(src);
      reject(err);
    };
    document.head.appendChild(script);
  });

  loadPromises.set(src, loadPromise);
  return loadPromise;
}

// Resolves once the element is registered, i.e. the module actually ran rather than just
// downloaded; rejects after timeoutMs. This also catches a <script> tag that already
// existed but failed or never finished, which loadGateScript() resolves straight away.
function confirmGateDefined(tagName = 'smartforms-techtarget', timeoutMs = 10000) {
  let timer;
  const timedOut = new Promise((_, reject) => {
    timer = setTimeout(() => reject(new Error(`Timed out waiting for <${tagName}> to be defined`)), timeoutMs);
  });
  const defined = customElements.whenDefined(tagName).then(() => {
    clearTimeout(timer);
    const ElementClass = customElements.get(tagName);
    return {
      registered: true,
      tagName,
      observedAttributes: ElementClass.observedAttributes || null,
    };
  });
  return Promise.race([defined, timedOut]);
}

export default loadGateScript;
export { confirmGateDefined };
